<template>
  <transition
    name="component-fade"
    mode="out-in"
  >
    <component
      :is="error"
      v-if="errorCode"
    />
    <slot v-else />
  </transition>
</template>
<script>
const Error400 = () => import('@/views/pages/error/Error400.vue')
const Error403 = () => import('@/views/pages/error/Error403.vue')
const Error404 = () => import('@/views/pages/error/Error404.vue')
const Error409 = () => import('@/views/pages/error/Error409.vue')
const Error500 = () => import('@/views/pages/error/Error500.vue')
const Error503 = () => import('@/views/pages/error/Error503.vue')

export default {
  components: {
    Error400,
    Error403,
    Error404,
    Error409,
    Error500,
    Error503,
  },
  computed: {
    errorCode() {
      return this.$store.state.app.errorCode
    },
    error() {
      return this.errorCode ? `error-${this.errorCode}` : null
    },
  },
}
</script>
